<template>
  <div>
    <div class="top">
      <div class="text">
        <div class="title">
          Ethnography
        </div>
        <div class="value">
          一种定性的方法，涉及到相对深入到一个特定的社区或情境中，近距离观察他们的行为和相互作用

        </div>
        <div><button @click="contact">联系我们</button></div>
      </div>
    </div>

    <div class="mid">
      <div class="value">
        我们的团队提供全面的项目管理，从招募受访者，交付和介绍测试产品，到指导和收集日记或家庭作业。

      </div>
    </div>

    <!-- Case Study -->
    <cn-case-study />

  </div>
</template>

<script>
import CnCaseStudy from "@/components/cncaseStudy";
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  components: {
    CnCaseStudy
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "ethnography",
          source: "",
          information: "Solutions_ethnography"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "ethnography",
          source: this.$route.query.source,
          information: "Solutions_ethnography"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/cn/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  padding: 150px 200px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/ethnography/ethnographybg.png");
  background-size: cover;
  // height: 600px;
  .text {
    width: 60%;
    margin-bottom: 35px;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
      color: #fff;
    }
    .value {
      font-size: 20px;
      color: #fff;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.mid {
  background-color: #2cb1e9;
  color: #fff;
  padding: 80px 120px;
  .value {
    padding: 50px;
    font-size: 25px;
    font-weight: 700;
  }
}
@media screen and (max-width: 576px) {
  .top {
    padding: 90px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .mid {
    padding: 90px 70px;
    .value {
      font-size: 70px;
    }
  }
}
</style>